import { ReactNode } from "react";
import s from "./Pill.module.scss";

export type Tone = "neutral" | "info" | "ok" | "warning" | "danger";

/** Status in WORDS (never colour alone). */
export const Pill = ({ tone = "neutral", icon, children }: { tone?: Tone; icon?: ReactNode; children: ReactNode }) => (
  <span className={`${s.pill} ${s[tone]}`}>{icon && <span aria-hidden className={s.icon}>{icon}</span>}{children}</span>
);
